import styled from 'styled-components';

const CheckboxInput = styled.input`
  &:checked ~ svg {
    transform: scale(1);
  }
`;

const RadioInput = styled.input`
  &:checked + div .indicator {
    display: inline-block;
  }
`;

export { CheckboxInput, RadioInput };
